import { yupResolver } from '@hookform/resolvers/yup';
import { Resolver } from 'react-hook-form';
import { OneActorSettingT, UpdateActorSettingT, CreateActorSettingT } from 'shared/api/types/services';
import * as Yup from 'yup';
import initDefaultSchema from '../yupConfig';

initDefaultSchema();

// Update Actor Setting
export type UpdateActorSettingFormT = UpdateActorSettingT['request'];
export const getUpdateActorSettingValues = (values?: OneActorSettingT['response'])
  : UpdateActorSettingFormT => ({
    text: values?.text,
    name: values?.name,
    description: values?.description,
  });
const updateActorSettingSchema: Yup.ObjectSchema<UpdateActorSettingFormT> = Yup.object({
  name: Yup.string().required(),
  text: Yup.string().required(),
  description: Yup.string(),
});
export const updateActorSettingResolver = yupResolver(updateActorSettingSchema) as Resolver<UpdateActorSettingFormT>;

// Create Actor Setting
export type CreateActorSettingFormT = CreateActorSettingT['request'];
export const getCreateActorSettingValues = ()
  : CreateActorSettingFormT => ({
    text: '',
    name: '',
    description: ''
  });
const createActorSettingSchema: Yup.ObjectSchema<CreateActorSettingFormT> = Yup.object({
  text: Yup.string().required(),
  name: Yup.string().required(),
  description: Yup.string(),
});
export const createActorSettingResolver = yupResolver(createActorSettingSchema) as Resolver<CreateActorSettingFormT>;
